
import Form from './form'
import Files from './files/index'

import ExtensionService from 'live/services/extension'
import { TYPE } from './interface/Config';

const s3 = {
    name: 'S3 integration',
    type: TYPE,
    origin: 'Plugin Upload S3',
    roles: [],
    icon: '/content/plugin-upload/s3.png',
    ui: {
        form: Form,
        view: null,
        custom: {
            'files': {
                label: 'Files',
                component: Files
            }
        }
    }
};

ExtensionService.register(s3);
